import { HorizontalDivider } from "./HorizontalDivider";

export { HorizontalDivider };
